/* eslint-disable no-restricted-globals */
/**
 * @description
 */

/* global ModuloTS */

(() => {
	// VARS
	const mainSearch = {
		root: document.querySelector('#facets .views-exposed-form'),
		submit: document.querySelectorAll('input[type=submit]'),
		input: document.querySelectorAll(
			'#facets .views-exposed-form input[type=text]'
		),
		title: document.querySelectorAll('.facets-links--title'),
		categ: document.querySelector(
			'#views-exposed-form-news-solr-block-news-solr'
		),
	};

	// FUNCTIONS

	/**
	 * @description
	 * Gestion des classes dynamiques
	 */

	const mainSearchClasses = () => {
		if (mainSearch.submit && typeof mainSearch.submit !== 'undefined') {
			mainSearch.submit.forEach((submit) => {
				submit.classList.remove('form-control-lg', 'form-control');
				submit.classList.add('btn', 'btn-primary');
			});
		}
	};

	const mainSearchInput = () => {
		if (mainSearch.input && typeof mainSearch.input !== 'undefined') {
			mainSearch.input.forEach((input) => {
				input.setAttribute('placeholder', ModuloTS['I search']);
			});
		}
	};

	const mainSearchIcons = () => {
		const items = document.querySelectorAll('.facets-links--title') || null;
		if (items) {
			items.forEach((item) => {
				const hasP = item.querySelector('p') || null;
				if(hasP){
					const getType =hasP.getAttribute('data-picto');
				let getPicto;
				if (getType === 'content_type') {
					getPicto = 'doc';
				} else if (getType === 'date') {
					getPicto = 'calendar';
				} else if (getType === 'keywords') {
					getPicto = 'keyword';
				}
				item.insertAdjacentHTML(
					'afterbegin',
					`<div class="view-filters__fieldset__icon"><i data-icon="${getPicto}"></i></div>`
				);
				}
			});
		}
	};

	const checkCategories = () => {
		const OldXHR = window.XMLHttpRequest;

		const newXHR = () => {
			const realXHR = new OldXHR();
			realXHR.addEventListener(
				'readystatechange',
				function () {
					if (realXHR.readyState === 4 && realXHR.status === 200) {
						afterAjaxComplete();
					}
				},
				false
			);
			return realXHR;
		};

		window.XMLHttpRequest = newXHR;

		const afterAjaxComplete = () => {
			const queryString = window.location.search;
			if (queryString !== '') {
				document.body.classList.add('actus-categ');
			} else {
				document.body.classList.remove('actus-categ');
			}
		};
	};

	const init = () => {
		mainSearchClasses();
		mainSearchIcons();
		mainSearchInput();
	};

	// GO 🚀
	if (document.body.contains(mainSearch.root)) {
		window.addEventListener('load', function () {
			init();
		});
	}

	if (document.body.contains(mainSearch.categ)) {
		checkCategories();
	}
})();
